import type { CiaDependencies } from '~/composables/useCia/types';
import { Logger } from '~~/helpers/logger';

type ContactFormSubmitParams = {
  caseId: string;
  caseData: Record<string, string | number>;
};

const getInvalidRequiredFields = ({ caseId, caseData }: ContactFormSubmitParams, locale: string): string[] => {

  const requiredFields = {
    caseId,
    SuppliedName: caseData.SuppliedName,
    SuppliedEmail: caseData.SuppliedEmail,
    Reason: caseData.Reason,
    languageAndCountry: locale,
    Subject: caseData.Subject,
    Description: caseData.Description,
  };

  return Object.entries(requiredFields)
    .filter(([, value]) => typeof value !== 'string' || value.trim().length === 0)
    .map(([field]) => field);

};

export default (dependencies: CiaDependencies) => {

  const { fetch, languageAndCountry } = dependencies;

  return async ({ caseId, caseData }: ContactFormSubmitParams): Promise<unknown> => {

    if (import.meta.server) {

      Logger.debug('cia|contactFormSubmit skipped: server-side execution');

      return;

    }

    const invalidFields = getInvalidRequiredFields({ caseId, caseData }, languageAndCountry);

    if (invalidFields.length > 0) {

      Logger.warn('cia|contactFormSubmit skipped: required fields are missing, blank or not strings', {
        invalidFields,
      });

      return;

    }

    const {
      SuppliedName,
      SuppliedCompany,
      SuppliedEmail,
      Reason,
      CaseSubReason__c,
      Subject,
      Description,
      ...additionalProps
    } = caseData;

    return fetch('/cia/contact-form-submit', {
      method: 'POST',
      body: {
        case_id: caseId,
        locale: languageAndCountry,
        supplied_name: SuppliedName,
        company_name: SuppliedCompany ?? '',
        email: SuppliedEmail,
        reason: Reason,
        case_sub_reason: CaseSubReason__c ?? '',
        subject: Subject,
        description: Description,
        additional_props: additionalProps,
      },
    });

  };

};
